module.exports = __webpack_public_path__ + "img/singleLineTextEle.caa9efa1.svg";